import * as R from 'ramda'

import * as notificationFormSelectors from 'src/components/user/NotificationSettings/selectors'
const { paths } = notificationFormSelectors

const notificationsFragment = {
  ':user/notification-settings': [
    ':db/id',
    paths.TYPE,
    paths.CHANNELS,
    paths.BOARD
  ]
}

const boardsFragment = {
  ':user/follows': [
    ':db/id',
    ':board/squuid',
    ':board/title',
    ':board/features',
    { ':board/network': [':db/id', ':network/default-board'] }
  ]
}

export const fragment = [R.mergeAll([notificationsFragment, boardsFragment])]
